import moment from 'moment-timezone';
import { constantConfig } from '../config/ConstantConfig';
import { ConstantType } from './ConstantType';
import { ConstantValueNotFound } from './ConstantValueNotFoundError';

export function getConst(name: ConstantType, date: string, timezone = 'Europe/Prague') {
  const targetTime = moment.tz(date, timezone);

  const records = constantConfig[name]
    .filter((record) => moment.tz(record.validSince, timezone) <= targetTime)
    .sort(
      (recordA, recordB) =>
        new Date(recordB.validSince).getTime() - new Date(recordA.validSince).getTime()
    );

  if (records.length <= 0) {
    throw new ConstantValueNotFound(name, targetTime.toDate());
  }

  return records[0].value;
}

export function getCurrentConsts() {
  const currentDate = new Date().toISOString();
  const timezone = "Europe/Prague";
  const targetTime = moment.tz(currentDate, timezone).toISOString();

  const keys = Object.keys(constantConfig) as (keyof typeof constantConfig)[];
  const result: Array<{ type: ConstantType; value: number }> = [];

  keys.forEach((key) => {
    const value = getConst(key, targetTime, timezone);
    if (value !== undefined) {
      result.push({
        "type": key,
        "value": value
      });
    }
  });

  return result;
}
